import { Col, Form, Input, InputNumber, Row, Select } from "antd";
import CustomDatePicker from "common/CustomDatePicker";
import moment from "moment";

const HourlyPackingConfirmationForm = (props) => {
  // Props
  const {
    poList,
    onChangeInternalPO,
    onChangeOriginalPO,
    isEdit,
    isFactory,
    editRecord,
    packingLinesList,
    packingTablesList,
    operatorsList,
    salesContractList,
    buyingOfficeList,
    buyerList,
    getPackingLines,
    getPackingTables,
    getOperators,
    getSalesContracts,
    getBuyingOffices,
    getBuyers,
    form,
  } = props;

  // Antd
  const { Option } = Select;

  return (
    <>
      {isEdit && editRecord ? (
        // Edit mode - show editable dropdowns
        <Row gutter={6}>
          <Col span={4}>
            <Form.Item label="Entry Date" name="entry_date">
              <CustomDatePicker style={{ width: "100%" }} size="small" disabled />
            </Form.Item>
          </Col>
          {/* <Col span={4}>
            <Form.Item label="Hour" name="hour">
              <InputNumber style={{ width: "100%" }} size="small" disabled min={1} max={24} />
            </Form.Item>
          </Col> */}
          <Col span={4}>
            <Form.Item
              label="Packing Line"
              name="packing_line_id"
              rules={[{ required: true, message: "Packing Line is required" }]}
            >
              <Select
                showSearch
                disabled
                placeholder="Select Packing Line"
                size="small"
                onSearch={(value) => getPackingLines(value)}
                onClear={() => getPackingLines()}
                optionFilterProp="children"
                filterOption={false}
                onChange={(value) => {
                  if (form) {
                    form.setFieldsValue({ packing_table_id: undefined });
                  }
                  if (getPackingTables) {
                    getPackingTables(value);
                  }
                }}
              >
                {packingLinesList.map((line) => (
                  <Option key={line.id} value={line.id}>
                    {line.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Packing Table"
              name="packing_table_id"
              rules={[{ required: true, message: "Packing Table is required" }]}
            >
              <Select
                showSearch
                disabled
                placeholder="Select Packing Table"
                size="small"
                onSearch={(value) => {
                  const packingLineId = form?.getFieldValue("packing_line_id");
                  if (getPackingTables) {
                    getPackingTables(packingLineId, value);
                  }
                }}
                onClear={() => {
                  const packingLineId = form?.getFieldValue("packing_line_id");
                  if (getPackingTables) {
                    getPackingTables(packingLineId);
                  }
                }}
                optionFilterProp="children"
                filterOption={false}
              >
                {packingTablesList.map((table) => (
                  <Option key={table.id} value={table.id}>
                    {table.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Operator"
              name="operator_id"
              rules={[{ required: true, message: "Operator is required" }]}
            >
              <Select
                showSearch
                disabled
                placeholder="Select Operator"
                size="small"
                onSearch={(value) => getOperators(value)}
                onClear={() => getOperators()}
                optionFilterProp="children"
                filterOption={false}
              >
                {operatorsList.map((operator) => (
                  <Option key={operator.id} value={operator.id}>
                    {operator.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Time Range">
              <Input
                disabled
                size="small"
                value={`${editRecord?.hour_time_range_from || ""} - ${editRecord?.hour_time_range_to || ""}`}
              />
            </Form.Item>
          </Col>
        </Row>
      ) : null}
      <Row gutter={6}>
        <Col span={4}>
          <Form.Item
            label="Original PO"
            name="original_po"
            rules={[{ required: !isEdit, message: `Original PO is required ` }]}
          >
            <Select
              onChange={onChangeOriginalPO}
              showSearch
              style={{
                width: "100%",
              }}
              placeholder="Search to Select"
              optionFilterProp="children"
              size="small"
              disabled={isEdit}
            >
              {poList &&
                poList?.map((po, idx) => (
                  <Option key={idx} value={po?.original_po}>
                    {po?.original_po}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            label="Internal PO"
            name="internal_po"
            rules={[
              {
                required: false,
                message: `Internal PO is required `,
              },
            ]}
          >
            <Select
              onChange={onChangeInternalPO}
              showSearch
              style={{
                width: "100%",
              }}
              placeholder="Search to Select"
              optionFilterProp="children"
              size="small"
              disabled={isEdit}
            >
              {poList &&
                poList?.map((po, idx) => (
                  <Option key={idx} value={po?.internal_po}>
                    {po?.internal_po}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        {isFactory ? (
          <>
            <Col span={4}>
              <Form.Item name="sub_contract_factory_id" hidden />
              <Form.Item
                name="sub_contract_factory_name"
                label="Factory Name"
                rules={[
                  {
                    required: true,
                    message: `Factory Name is required `,
                  },
                ]}
              >
                <Input disabled={true} size="small" />
              </Form.Item>
            </Col>
          </>
        ) : (
          <>
            <Col span={0}>
              <Form.Item name="buying_office_id" />
            </Col>
            <Col span={4}>
              <Form.Item
                name="buying_office_name"
                label="Buying Office"
                rules={[
                  {
                    required: true,
                    message: `Buying Office is required `,
                  },
                ]}
              >
                <Input disabled={true} size="small" />
              </Form.Item>
            </Col>
            <Col span={0}>
              <Form.Item name="buyer_id" />
            </Col>
            <Col span={4}>
              <Form.Item
                name="buyer_name"
                label="Buyer"
                rules={[
                  {
                    required: true,
                    message: `Buyer is required `,
                  },
                ]}
              >
                <Input disabled={true} size="small" />
              </Form.Item>
            </Col>
          </>
        )}
        <Col span={0}>
          <Form.Item name="sales_contract_id" />
        </Col>
        <Col span={0}>
          <Form.Item name="po_map_id" />
        </Col>
        <Col span={4}>
          <Form.Item name="reference_no" label="Sales Contract No. / Sub Contract No.">
            <Input disabled={true} size="small" />
          </Form.Item>
        </Col>
        {/* <Col span={4}>
          <Form.Item
            name="start"
            label="From"
            rules={[
              {
                required: true,
                message: `Start number is required `,
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} size="small" disabled={isEdit} />
          </Form.Item>
        </Col> */}
        {/* <Col span={4}>
          <Form.Item
            name="end"
            label="To"
            rules={[
              {
                required: true,
                message: `End number is required `,
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} size="small" disabled={isEdit} />
          </Form.Item>
        </Col> */}
        <Col span={4}>
          <Form.Item label="Packing Date" name="packing_date" initialValue={moment()}>
            <CustomDatePicker style={{ width: "100%" }} size="small" disabled={isEdit} />
          </Form.Item>
        </Col>
      </Row>
      {isEdit && editRecord ? (
        // Show additional editable dropdowns in edit mode
        <Row gutter={6}>
          <Col span={4}>
            <Form.Item
              label="Sales Contract"
              name="sales_contract_id"
              rules={[{ required: true, message: "Sales Contract is required" }]}
            >
              <Select
                showSearch
                disabled
                placeholder="Select Sales Contract"
                size="small"
                onSearch={(value) => getSalesContracts(value)}
                onClear={() => getSalesContracts()}
                optionFilterProp="children"
                filterOption={false}
              >
                {salesContractList.map((contract) => (
                  <Option key={contract.id} value={contract.id}>
                    {contract.reference_no}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Buying Office"
              name="buying_office_id"
              rules={[{ required: true, message: "Buying Office is required" }]}
            >
              <Select
                showSearch
                disabled
                placeholder="Select Buying Office"
                size="small"
                onSearch={(value) => getBuyingOffices(value)}
                onClear={() => getBuyingOffices()}
                optionFilterProp="children"
                filterOption={false}
              >
                {buyingOfficeList.map((office) => (
                  <Option key={office.id} value={office.id}>
                    {office.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Buyer" name="buyer_id" rules={[{ required: true, message: "Buyer is required" }]}>
              <Select
                showSearch
                disabled
                placeholder="Select Buyer"
                size="small"
                onSearch={(value) => getBuyers(value)}
                onClear={() => getBuyers()}
                optionFilterProp="children"
                filterOption={false}
              >
                {buyerList.map((buyer) => (
                  <Option key={buyer.id} value={buyer.id}>
                    {buyer.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="PO" name="po_map_id" rules={[{ required: true, message: "PO is required" }]}>
              <Select showSearch placeholder="Select PO" size="small" optionFilterProp="children" disabled>
                {poList?.map((po, idx) => (
                  <Option key={idx} value={po?.id}>
                    {po?.original_po}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {editRecord?.sub_contract_factory_info ? (
            <Col span={4}>
              <Form.Item label="Sub Contract Factory" name="sub_contract_factory_id">
                <Input disabled size="small" value={editRecord?.sub_contract_factory_info?.name} />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
      ) : null}
    </>
  );
};

export default HourlyPackingConfirmationForm;
